export default {
  blends: {
    validationMessage:{
      requiredMessage:'This field is required',
      isNumber:'Must be a number',
      isValidNumber:'Must be a valid number',
      noNegativeNumbers:'This field must be greater than zero',
      atLeastTwoProducts:'At least two products are required',
    },
    exemptProducts: {
      eudrExemptProducts: 'EUDR-Exempt Products',
      addEUDRExemptProduct: 'Add EUDR-Exempt Product',
      updateEUDRExemptProduct: 'Update EUDR-Exempt Product',
      internalRefNumber: 'Internal Reference Number',
      supplier: 'Supplier',
      containerID: 'Container ID',
      product: 'Product',
      quantity: 'Quantity',
      dateAdded: 'Date Added',
      addProduct: 'Add Product',
      selectDate: 'Select Date',
      addContainer: 'Add Container',
      containerInformation: 'Container Information',
      containerInformationTT: 'This is a unique identifier of Container. Please insert Container ID below.',
      supplierInformation: 'Supplier Information',
      supplierInformationTT:
        'Details about the entity providing goods or services.',
      supplierTooltip:
        'Select the supplier from the pre-registered list in the system.',
      addnewSupplier: 'Add New Supplier',
      internalReferenceNumberMustBeAlphanumeric:
        'Internal reference number must be alphanumeric',
      netMassMustBeValid: 'Net mass must be valid',
      volumeMustBeNumeric: 'Volume must be numeric',
      subProduct: 'Sub-Product',
      netMass: 'Net Mass',
      volume: 'Volume',
      productDetail: 'Product Details',
      placeOfActivity: 'Place of Activity',
      countryOfActivity: 'Country of Activity',
      countryOfEntry: 'Country of Entry',
      activity: 'Activity',
      internalRefNo: 'Internal Reference Number',
      name: 'Name',
      email: 'Email',
      phoneNumber: 'Phone Number',
      country: 'Country',
      status: 'Statue',
      addNewSupplier: 'Add a New Supplier',
      availableForBlends: 'Available for Blends',
      thisFieldIsRequired: 'This field is required.',
      enterSupplierFirstName: 'Enter Supplier First Name',
      enterSupplierLastName: 'Enter Supplier Last Name',
      enterEmailAddress: 'Enter Email Address',
      enterPhoneNumber: 'Enter Phone Number',
      selectCountry: 'Select Country',
      firstNameIsRequired: 'First name is required',
      lastNameIsRequired: 'Last name is required',
      unAvailableForBlends: 'Unvailable for Blends',
      exemptAddedSuccessfully: 'EUDR-exempt product has been added successfully!',
      unExpectedErrorMsg: 'An unexpected error occurred. Please try again.',
      availabilityStatusMsg:
        'The availability status for blends has been successfully updated.',
      updateProduct: 'Update Product',
      exemptUpdatedSuccessfully:
        'EUDR-exempt product has been updated successfully!',
      invalidNumericValue: 'Invalid numeric value',
      containerIDTT:
        'This is a unique identifier of Container. Please insert Container ID below',
        actions: 'Actions',
    },
  
    blends: 'Blends',
    blendSetting: 'Blend Settings',
    eudrDueDiligence: 'EUDR Due Diligence',
    createBlendDds: 'Create Blend DDS',
    country: 'Country',
    countryTT: 'Country',
    select: 'Select',
    edurDueDeligenceStatus: 'EUDR Due Diligence Status',
    dueDiligenceStatus: 'Due Diligence Status',
    EUDRDeforestationStatusTT: 'EUDR Deforestation Status',
    dueDeligenceStatus: 'Due Diligence Status',
    uploadedToEU: 'Uploaded to EU',
    pending: 'Pending',
    underReview: 'Under Review',
    compliant: 'Compliant',
    nonCompliant: 'Non-Compliant',
    processingFarm: 'Processing Farm',
    analyzingDeforestation: 'Analyze Deforestation',
    writingToBlockchain: 'Writing to Blockchain',
    readyToProceed: 'Ready to Proceed',
    mitigationRequired: 'Mitigation Required',
    viewReport: 'View Report',
    share: 'Share',
    copyAndCreateNew: 'Copy and Create New',
    remove: 'Remove',
    eudrRefNo: 'EUDR/Internal Reference No.',
    finalProduct: 'Blend Title & Blend Lot ID',
    noOfIngredients: 'No. of Ingredients',
    farmsAndQuantity: 'Farms & Quantity',
    actions: 'Actions',
    confirmDialog: {
      delete: {
        title: 'Delete Blend',
        message: 'Are you sure you want to delete this Blend?',
        confirmBtn: 'Confirm',
        cancelBtn: 'Cancel',
      },
    },
    searchBlend: 'Search by Blend Title or Blend Lot ID',
    blendDuplicatedSuccessfully: 'Blend has been duplicated successfully.',
    reportDeletedSuccessfully: 'Report deleted successfully',
    
    blendSettings: {
      dashboard: 'Dashboard',
      blendSettings: 'Blend Settings',
      importBlends: 'Import Blends',
      addNewBlend: 'Add New Blend',
      searchTitle: 'Search By Blend Title',
      view: 'View',
      edit: 'Edit',
      remove: 'Remove',
      farms: 'Farms',
      blendCode: 'Blend Code',
      blendTitle: 'Blend Title',
      description: 'Description',
      'finalProductName&Code': 'Final Product Name & Code',
      dateAdded: 'Date Added',
      actions: 'Actions',
      addBlend: 'Add Blend Settings',
      cancel: 'Cancel',
      createBlend: 'Create Blend Settings',
      generalData: 'General Data',
      generalDataTT: 'This label shows all the data in the screen.',
      blendTitleTT: 'The dropdown can be accessed by clicking on it, which reveals a list of available blends for selection.',
      enterHere: 'Enter here',
      blendCodeTT: 'A textbox for inputting the unique code assigned to the blend for identification.',
      blendDescription: 'Blend Description',
      blendDescriptionTT: 'A textbox for providing a detailed description of the blend.',
      finalProductName: 'Final Product Name',
      finalProductNameTT: 'A textbox for entering the name of the final product associated with the blend.',
      finalProductCode: 'Final Product Code',
      finalProductCodeTT: 'A textbox for inputting the code of the final product related to the blend.',
      processType: 'Process Type',
      processTypeTT: 'A dropdown to display type of roasting or blending process used for this blend.',
      finalProductLotIdGen: 'Blend Final Product Lot ID Generator',
      finalProductLotIdGenTT: 'Choose a type for the Lot ID structure. Options determine how the ID is generated and can include static text, sequential numbers, or date-based elements.',
      productDetails: 'Blend Products (Ingredients)',
      productDetailsTT: 'Add at least 2 products and sub-products. To add more, click "Add Another Product."',
      selectType: 'Select Type',
      startCount: 'Start Count',
      resetCounterEach: 'Reset Counter Each ',
      enter: 'Enter',
      staticText: 'Static Text',
      incrementalNumber: 'Incremental Number',
      year: 'Year',
      month: 'Month',
      date: 'Date',
      none: 'None',
      space: 'Space',
      '0001': '0001',
      resetCounter: 'Reset counter each',
      selectSeparator: 'Select Separator',
      previewLotId: 'Preview Lot ID',
      blendProducts: 'Blend Products',
      blendProductsTT: 'Blend Products',
      product: 'Product',
      productTT: 'A dropdown for selecting the primary product category.',
      selectProduct: 'Select Product',
      subProduct: 'Sub Product',
      subProductTT: 'A dropdown for choosing the specific sub-product related to the selected product.',
      selectSubProduct: 'Select Sub Product',
      originCountry: 'Origin Country',
      originCountryTT: 'Select the country where the ingredient originated.',
      selectCountry: 'Select Country',
      percentage: 'Percentage',
      percentageTT: 'Enter the percentage of the current product in the overall blend. The total percentage must add up to 100.',
      addAnotherProduct: 'Add Another Product',
      confirmation: 'Confirmation',
      createBlendMessage: 'Are you sure you want to add new blend?',
      updateBlendMessage: 'Are you sure you want to update this blend?',
      confirm: 'Confirm',
      pleaseFillRequiredFields: 'Please fill required fields',
      lightRoast: 'Light Roast',
      mediumRoast: 'Medium Roast',
      mediumDarkRoast: 'Medium-Dark Roast',
      darkRoast: 'Dark Roast',
      validation: {
        titleRequired: 'Title is required',
        codeRequired: 'Blend Code is required',
        descriptionRequired: 'Description is required',
        finalProductNameRequired: 'Final Product Name is required',
        finalProductCodeRequired: 'Final Product Code is required',
        processTypeRequired: 'Process Type is required',
        selectTypeRequired: 'Type is required',
        startCountRequired: 'Start Count is required',
        selectSeparatorRequired: 'Select Separator is required',
        finalProductLotIdGenRequired:
          'Final Product Lot ID Generation is required',
        productRequired: 'Product is required',
        subProductRequired: 'Sub Product is required',
        originCountryRequired: 'Origin Country is required',
        percentageRequired: 'Percentage is required',
        hundredPrecent: 'Total percent must add up 100 % exact',
        productSubproductDuplicatedMsg: 'Product and Sub Product is duplicated',
      },
      mustSelectIncrementalNumber: 'At least one Incremental Number is required',
      blendSettingsCreated: 'Blend Settings has been successfully created.',
      blendSettingsNotCreated:
        'Blend Settings Creation Unsuccessful. Please try again with proper data.',
      confirmDiaglog: {
        delete: {
          title: 'Delete',
          message: 'Are you sure you want to delete this Blend Settting?',
          confirmBtn: 'Confirm',
          cancelBtn: 'Cancel',
        },
      },
      itemDeletedSuccessfully: 'Blend Setting deleted successfully',
      updateBlend: 'Update Blend Settings',
      save: 'Save',
      blendSettingsUpdated: 'Blend Settings has been successfully updated.',
      blendSettingsNotUpdated:
        'Blend Settings Update Unsuccessful. Please try again with proper data.',
      updateMessage: 'Are you sure you want to update this blend?',
      createMessage: 'Are you sure you want to add new blend?',
      finalProductCodeAlreadyExists: 'The final product code already exists',
      blendCodeAlreadyExists: 'The blend code already exists.',
      valueMustBeNumber: 'This field must be a number',
      valueMustBeNonNegative: 'This field must be greater than zero',
    },
    
    imports: {
      imports: 'Imports',
      blends: 'Blends',
      createNewImport: 'Create New Import',
      importsBlends: 'Imports Blends',
      createBlends: 'Create Blends',
      downloadTemplateInfo:
        'Download and use the below templates to bulk import geofences.',
      selectTemplate: 'Select Template',
      downloadXlsTemplate: 'Download XLS Import Template Format',
      downloadProductCodes: 'Download Product Codes',
      selectFileToUpload: 'Select file to upload data',
      orDragDrop: 'Or drag and drop files here',
      removeFile: 'Remove File',
      importantNote: 'Important Note',
      templateNote:
        'Please use the provided templates above for bulk uploads. Other formats will result in failure.',
      importData:'Please be sure that these data will not be preserved until all status is success.',
      fileUploadSuccess: 'File uploaded successfully',
      invalidFileFormat: 'Invalid file format. Please upload a valid file',
      invalidTemplateUploaded:'Invalid template uploaded. Please use the correct template and try again.',
      invalidTemplateUploadedMissing:'Invalid template uploaded. Please use the correct template and try again. Missing these',
      pleaseSelectSource: 'Please select at least one source',
      blendTitle: 'Blend Title',
      blendCode: 'Blend Code',
      finalProductCode: 'Final Product Code',
      finalProductName: 'Final Product Name',
      status: 'Status',
      downloadCsvTemplate: 'Download CSV Import Template Format',
      dropHere: 'or drag and drop here',
      Importing: 'Importing...',
      modalMessage:
        'Your uploaded file are currently being processed. We will notify once file has been uploaded successfully.',
      importXLSFormat: 'Import XLS Format',
      importCSVFormat: 'Import CSV Format',
      fileSelected: 'The file has been selected successfully.',
      success: 'Data has been successfully imported.',
      importCompleted: 'Import Completed',
      invalidHeaders: "Invalid File Headers",
      headerMismatchErro: "The uploaded file must contain the following headers",
      missingHeaders: "Missing Headers",
      additionalHeaders: "Additional Headers (not allowed)"
    },
    history: {
      history: 'History',
      fileName: 'File Name',
      importedOn: 'Imported On',
      status: 'Status',
      action: 'Action',
      blends: 'Blends',
      download: 'Download',
      success: 'Success',
      failed: 'Failed'
    },
    createBlends: {
      eudrDueDiligence: 'EUDR Due Diligence',
      createBlends: 'Create Blends',
      discard: 'Discard',
      reject: 'Reject',
      saveAndContinueLater: 'Save and Continue Later',
      generateReport: 'Generate Report',
      generalData: 'General Data',
      blend: 'Blend',
      selectBlend: 'Select Blend',
      blendCode: 'Blend Code',
      blendDescription: 'Blend Description',
      finalProduct: 'Final Product',
      finalProductCode: 'Final Product Code',
      netMass: 'Net Mass',
      netMassTT: 'Allows users to enter the net mass tax value associated with a product, shipment, or transaction.',
      volume: 'Volume',
      volumeTT: 'The label is prominently displayed next to a field or section where volume-related data is presented or input, such as in product specifications or shipping forms.',
      blendLotId: 'Blend Lot ID',
      blendLotIdTT: 'Shows the unique lot identifier according to Blend settings configuration for tracking the blend batch.',
      finishedProductLotId: 'Finished Product Lot ID',
      finishedProductLotIdTT: 'Enter the unique lot identifier for tracking the final product batch',
      enterHere: 'Enter Here',
      internalReferenceNumber: 'Internal Reference Number',
      internalReferenceNumberTT: 'Internal reference code for tracking purposes',
      eudrReferenceNumber: 'EUDR Reference Number',
      eudrReferenceNumberTT: 'EUDR (European Union Deforestation Regulation) compliance reference code. This will be auto-populated if user wishes to upload to EUDR after report creation.',
      companyId: 'Company ID',
      companyIdTT: 'Identifier for the company associated with this blend.',
      activity: 'Activity',
      domestic: 'Domestic',
      import: 'Import',
      export: 'Export',
      containerInformation: 'Container Information',
      containerInformationTT: 'This is a unique identifier of Container. Please insert Container ID below.',
      addContainer: 'Add Container',
      blendProduct: 'Blend Product',
      blendProductTT: 'Add multiple Product and Sub Products from DDS/EUDR Exempt Product for creating a Blend',
      product: 'Product',
      productTT: 'Shows users the product that was chosen from a list of available products in Blend Setting for processing, analysis, or reporting within the application, facilitating accurate data entry and management.',
      subProduct: 'Sub-Product',
      subProductTT: 'Shows users the sub-products that was chosen from available sub-products in Blend Setting related to a selected main product, facilitating detailed data entry and management within the application.',
      ddsId: 'DDS ID',
      containerId: 'Container ID',
      uniqueContainerId:"Container ID must be unique",
      containerIdTT: 'Unique identifier for the container carrying this blend',
      country: 'Country',
      countryTT: 'Choose the country associated with the blend’s origin or destination.',
      search: 'Search',
      select: 'Select',
      addAnotherProduct: 'Add Another Product',
      customization: 'Customization',
      recordsPerPage: 'Records per page',
      restoreDefault: 'Restore Default',
      apply: 'Apply',
      applyFilter:"Apply Filter",
      clearFilter:"Clear Filter",
      status: {
        compliant: 'Compliant',
        nonCompliant: 'Non-Compliant',
        eudrExempt: "EUDR Exempt",
        uploadToEudr:"UPLOADED TO EU PORTAL"
      },
      table: {
        eudrInternalRef: 'EUDR / Internal Reference No.',
        containerId: 'Container ID',
        product: 'Product',
        farmsQuantity: 'Farms & Quantity',
        submissionDate: 'Submission Date',
        dueDiligenceStatus: 'Due Diligence Status',
        availabilityForBlends: 'Availability for Blends',
        pleaseSelectSource: 'Please select at least one source',
      },
      productionPlaceTable: {
        productionPlaceAndFarmId: 'Production Place & Farm ID',
        product: 'Product',
        producerName: 'Producer Name',
        addressOfProduction: 'Address Of Production',
        status: 'EUDR Deforestation Status',
        riskAssessment: 'Risk Assessment',
      },
      addNewSupplier: 'Add a New Supplier',
      addNewBlend: 'Add New Blend',
      placeOfActivity: 'Operator Place of Activity',
      placeOfActivityTT: "Specify the operator's country where activities are conducted and the country where the product will enter the EU market. These details are essential for accurate compliance with EUDR requirements.", 
      countryOfActivity: 'Operator Country of Activity',
      countryOfActivityTT: 'Select the country where this activity takes place',
      countryOfEntry: 'Country of Entry',
      countryOfEntryTT: 'Select the entry point country for imported products',
      pleaseSelectAtLeastOne: 'Please select at least one report of each product',
      blendCreatedSuccessfully: 'Blend has been created successfully.',
      blendCreateFailed: "An error occurred while creating the blend",
      blendUpdatedSuccessfully: 'Blend has been updated successfully.',
      blendUpdateFailed: "An error occurred while updating the blend",
      blendDeletedSuccessfully: 'Blend has been deleted successfully.',
      blendSavedSuccessfully: 'Blend has been saved successfully.',
      blendUploadedToEUSuccessfully: 'Blend has been uploaded to EU successfully.',
      declaration_first: "{name}, hereby declare that all data submitted with this shipment is accurate to the best of my knowledge and belief.",
      declaration_second: "I, {name}, affirm that I have visited the farms associated with this shipment and confirm their compliance with local laws and regulations regarding deforestation."
    },
    manageProducts: {
      addNewProduct: 'Add New Product',
      editProduct: 'Edit Product',
      addNewSubProduct: 'Add New Sub-Product',
      editSubProduct: 'Edit Sub-Product',
      productTitle: 'Product Title',
      subProductTitle: 'Sub-Product Title',
      typeTitle: 'Type title',
      hsCode: 'HS Code',
      typeHSCode: 'Type HS code',
      eudrDocumentCode: 'EUDR Document Code',
      selectEudrDocumentCode: 'Select EUDR Document Code',
      makeSelection: 'Make a selection',
      uploadCategoryImage: 'Upload Category Image',
      addImage: 'Add Image',
      cancel: 'Cancel',
      save: 'Save',
      back: 'Back',
      add: 'Add',
      confirm: 'Confirm',
      deleteMessage: 'Are you sure you want to remove',
      invalidFileType: 'Invalid File Type',
      errorUploadingFile:
        'An unexpected error occurred while uploading the file. Please try again later.',
      fileUploadFailed: 'File Upload Failed',
      selectDocumentCode: 'Select Document Code',
      view: 'View',
      edit: 'Edit',
      remove: 'Remove',
      search: 'Search',
      searchByProductName: 'Search By Product Name',
      eudrDueDiligence: 'EUDR Due Diligence',
      products: 'Products',
      subProducts: 'Sub-Products',
      fieldRequired: 'This field is required',
      fileRequired: 'File Required',
      fileRequiredMessage:
        'Please upload or select a file before saving the product.',
      addNewDocumentCode: 'Add New Document Code',
      enterHere: 'Enter here',
      documentCode: 'Document Code',
      title: 'Title',
      description: 'Description',
      updateProduct: 'Update Product',
      updateSubProduct: 'Update Sub Product',
      deleteSubProduct: 'Delete Sub Product',
      deleteProduct: 'Delete Product',
      productAddedMessage: 'Product has been successfully added.',
      subProductAddedMessage: 'Sub Product has been successfully added.',
      productUpdateMessage: 'Product has been successfully updated.',
      subProductUpdateMessage: 'Sub Product has been successfully updated.',
      subProductDeleteMessage: 'Sub Product has been successfully deleted.',
      productDeleteMessage: 'Product has been successfully deleted.',
      pleaseTryAgain: 'Something went wrong. Please try again later.',
      documentCodeDuplicate: 'Document code already exists',
      unsupportedFileFormat: 'Unsupported file type. Please upload a valid image file.',
      tableHeaders: {
        productName: 'Product Name',
        hsCode: 'HS Code',
        eudrDocumentCode: 'EUDR Document Code',
        subProduct: 'Sub Products',
        dateAdded: 'Date Added',
        action: 'Actions',
      },
      documentCodeSaved: 'Document Code has been successfully saved.',
    },
    finalReport: {
      title: 'Final Report Blends',
      reportStatus: 'Report Status',
      blendTitle: 'Blend Title',
      blendCode: 'Blend Code',
      finalProduct: 'Final Product',
      finalProductCode: 'Final Product Code',
      blendDescription: 'Blend Description',
      processType: 'Process Type',
      netMass: 'Net Mass',
      volume: 'Volume',
      blendLotId: 'Blend Lot ID',
      finalProductLotId: 'Final Product Lot ID',
      internalReferenceNumber: 'Internal Reference Number',
      eudrReferenceNumber: 'EUDR Reference Number',
      activity: 'Activity',
      countryOfActivity: 'Country of Activity',
      countryOfEntry: 'Country of Entry',
      dueDiligenceReportStatus: 'Due Diligence Report Status',
      containerId: 'Container ID',
      operatorData: 'Operator Data',
      name: 'Name',
      country: 'Country',
      isoCode: 'ISO Code',
      eoriNumber: 'EORI Number',
      reportSummary: {
        title: 'Report Summary',
        totalDdsReports: 'Total Number of DDS Reports',
        totalGeofencePolygons: 'Total Number of Geofence Polygons',
        totalGeofencePoints: 'Total Number of Geofence Points',
        totalDeforestationAssessments:
          'Total Number of Deforestation Assessments',
        totalRiskAssessments: 'Total Number of Risk Assessments',
        totalFarms: 'Total Number of Farms',
        totalHighDeforestationFarms: 'Total Number of High Deforestation Farms',
        totalLowZeroRiskFarms: 'Total Number of Low and Zero Risk Farms',
        totalArea: 'Total Area (ha)',
        averageGeofenceArea: 'Average Geofence Area (ha)',
        totalHighRiskFarmArea: 'Total Area of High Risk Farm',
        totalLowZeroRiskFarmArea: 'Total Area of Low and Zero Risk Farm',
        productionPlaces: 'Production Places',
        productionPlacesTooltip: 'Details about the production locations',
        declarationStatement: 'Declaration Statement by Operator',
        declarationStatementTooltip: 'Official declaration by the operator',
        declarationText1:
          '[Name] {name}, hereby declare that all data submitted with this shipment is accurate to the best of my knowledge and belief.',
        declarationText2:
          'I, [Name] {name} affirm that I have visited the farms associated with this shipment and confirm their compliance with local laws and regulations regarding deforestation.',
      },
      blendProducts: {
        title: 'Blend Products',
        product: 'Product',
        subProduct: 'Sub Product',
        country: 'Country',
        reference: 'EUDR / Internal Reference No.',
        containerId: 'Container ID',
        farmsQuantity: 'Farms & Quantity',
        submissionDate: 'Submission Date',
        status: 'Status',
      },
      activityLog: {
        title: 'Activity Log',
        user: 'User',
        userRole: 'User Role',
        ipAddress: 'IP Address',
        dateTime: 'Date & Time',
        segment: 'Segment',
        activityDescription: 'Activity Description',
      },
      declaration: {
        title: 'Declaration Statement by Operator',
        name: 'Name',
        address: 'Address',
        dateTime: 'Date & Time',
      },
      buttons: {
        discard: 'Discard',
        reject: 'Reject',
        edit: 'Edit',
        finalize: 'Finalize',
        download: 'Download',
        uploadToEuPortal: 'Upload to EU Portal',
        update: 'Update',
        submit: 'Submit',
      },
    },
  }
};